import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocalizedPipe } from '../localized.pipe';
import { FollowupService } from '../services/followup.service';
import { UserMessageComponent } from '../messages/user-message/user-message.component';
import { OutreachOptions, OutreachScope, OutreachSelection, outreachIds } from './outreach-selection';

@Component({selector:'app-outreach-recipients',standalone:true,imports:[CommonModule,FormsModule,LocalizedPipe,UserMessageComponent],templateUrl:'./outreach-recipients.component.html',styleUrls:['./outreach.scss']})
export class OutreachRecipientsComponent implements OnChanges, OnDestroy {
 @Input() seedMemberIds:number[]=[];
 @Input() disabled=false;
 @Output() selectionChange=new EventEmitter<OutreachSelection>();
 options:OutreachOptions;
 scope:OutreachScope='member'; householdIds:string[]=[]; customIds:number[]=[];
 loading=false; error=false; private version=0;
 constructor(private followup:FollowupService,private changeDetector:ChangeDetectorRef){}
 ngOnChanges(changes:any){if(changes.seedMemberIds)void this.load();}
 ngOnDestroy(){this.version++;}
 get ids(){return this.options?outreachIds(this.options,this.scope,this.householdIds,this.customIds):[];}
 get included(){const ids=this.ids;return this.options?.members.filter(m=>ids.includes(m.memberId))||[];}
 async load(){
  const version=++this.version;this.loading=true;this.error=false;this.options=null;this.scope='member';this.emit();
  try{
   const options=await this.followup.outreachRecipients([...new Set(this.seedMemberIds)]);
   if(version!==this.version)return;
   if(!options||!Array.isArray(options.members)||!Array.isArray(options.households)||!Array.isArray(options.seedMemberIds)||!Array.isArray(options.primaryMemberIds))throw Error('Invalid recipients');
   this.options=options;this.householdIds=[];this.customIds=[...options.seedMemberIds];
  }catch{if(version===this.version)this.error=true;}
  finally{if(version===this.version){this.loading=false;this.emit();this.changeDetector.markForCheck();}}
 }
 setScope(scope:OutreachScope){if(this.disabled||this.loading)return;this.customIds=this.ids;this.scope=scope;this.emit();}
 toggleHousehold(id:string,checked:boolean){if(this.disabled)return;this.householdIds=checked?[...new Set([...this.householdIds,id])]:this.householdIds.filter(x=>x!==id);this.emit();}
 togglePerson(id:number,checked:boolean){if(this.disabled)return;this.customIds=checked?[...new Set([...this.customIds,id])]:this.customIds.filter(x=>x!==id);this.emit();}
 selectAll(){if(this.disabled)return;this.customIds=this.options.members.map(m=>m.memberId);this.emit();}
 clear(){if(this.disabled)return;this.customIds=[];this.emit();}
 private emit(){this.selectionChange.emit({seedMemberIds:[...this.seedMemberIds],memberIds:this.ids,members:this.included,ready:!!this.options&&!this.loading&&!this.error});}
}
